export const TEXT_SETUP_STARTING_QUARTER = 'Размести стартовый квартал на любой ячейке с флагом твоего цвета'
export const TEXT_SETUP_STARTING_QUARTER_WAIT_OTHERS = 'Подожди, другие игроки еще не разместили свои стартовые кварталы'